import {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import {DescriptionHeaderViewModel} from "./description-header.view-model";
import {PartialGameViewModel} from "../../../../domain/partial-game/models/partial-game-view-model";
import {CompetitorViewModel} from "../../../../domain/common/competitor/models/competitor-view-model";
import {GameCenterLinkModel} from "../../../../containers/game-center-container/models/game-center.link-model";
import {GameCenterHashParamsModel} from "../../../../containers/game-center-container/models/game-center.hash-params-model";

export class DescriptionHeaderGameViewModel extends DescriptionHeaderViewModel {
  get id(): Number {
    return this.entity?.id
  }

  get color(): String {
    return this.entity?.competition?.color
  }

  get textureId(): Number {
    return this.entity?.competition?.id
  }

  get objectType(): EntityViewModel {
    return PartialGameViewModel.name;
  }

  get popularityRank(): String {
    return null;
  }

  get extraIds() {
    const extraIds = [
      {id: this.entity?.homeCompetitor?.id, type: CompetitorViewModel.name},
      {id: this.entity?.awayCompetitor?.id, type: CompetitorViewModel.name}
    ]

    return extraIds
  }

  get useLink(): Boolean {
    return true;
  }

  get linkModel(): GameCenterLinkModel {
    let linkModel: GameCenterLinkModel = null;
    if(this.useLink && this.entity) {
      const hashParams: GameCenterHashParamsModel = new GameCenterHashParamsModel({id: this.entity.id});
      linkModel = new GameCenterLinkModel(this.entity.matchupId, this.entity.competition.sport.nameForURL, this.entity.competition.nameForURL, this.entity.nameForUrl, hashParams, this.entity.isFollow);
    }
    return linkModel;
  }

  get shouldRenderPopularityRank(): Boolean {
    return false
  }
}
